import { render, staticRenderFns } from "./TheWorkflowReport.vue?vue&type=template&id=f10ba60e&scoped=true&"
import script from "./TheWorkflowReport.vue?vue&type=script&lang=js&"
export * from "./TheWorkflowReport.vue?vue&type=script&lang=js&"
import style0 from "./TheWorkflowReport.vue?vue&type=style&index=0&id=f10ba60e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10ba60e",
  null
  
)

export default component.exports